<template>
  <section class="workgroup-container">


    <div class="vl-grid vl-grid--is-stacked">
      <div class="vl-col--1-8 vl-col--1-3--s vl-col--1-2--xs">
        <label for="workgroupFilter" class="vl-form__label __field__label">Werkgroep</label>
        <div class="search-wrapper flex-grow relative">
        <span class="vl-icon vl-vi vl-vi-search search-icon" aria-hidden="true"></span>
        <input type="text" id="workgroupFilter" v-model="search" class="vl-input-field search-input" placeholder="Werkgroep zoeken" />
      </div>
      </div>
      <div class="vl-col--1-4 vl-col--1-3--s vl-col--1-2--xs">
        <label for="statusFilter" class="vl-form__label __field__label">Status</label>
        <select id="statusFilter" v-model="statusFilter" class="vl-select--block vl-select vl-select--block">
          <option value="all">Alles</option>
          <option value="enabled">Ingeschakeld</option>
          <option value="disabled">Uitgeschakeld</option>
        </select>
      </div>

    </div>

    <!-- Workgroup List -->
    <ul class="workgroup-list dark:bg-zinc-800 mt-4">
      <li v-for="wg in sortedAndFilteredWorkgroups" :key="wg.id"
        class="workgroup-item flex justify-between items-center">
        <div class="workgroup-info">
          <span class="font-medium" :class="{ 'text-red-600': !wg.name }">
            {{ wg.name }}
          </span>
          <small v-if="!wg.isEnabled" class="text-gray-500 mt-0.5 block">
            Uitgeschakeld in: <span class="font-medium">{{ wg.disabledIn.join(', ') }}</span>
          </small>
        </div>
        <div :class="wg.isEnabled ? 'vl-pill vl-pill--success' : 'vl-pill vl-pill--error'">
          <span class="vl-pill__text">
            {{ wg.isEnabled ? 'Ingeschakeld' : 'Uitgeschakeld' }}
          </span>
        </div>
      </li>
    </ul>

    <div v-if="!sortedAndFilteredWorkgroups.length" class="no-workgroup mt-2">
      <span class="vl-icon vl-vi vl-vi-info-circle no-templates-icon" aria-hidden="true"></span>
      Er zijn nog geen werkgroepen toegewezen.
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'WorkgroupSettings',
  data() {
    return {
      search: '',
      sortAsc: true,
      statusFilter: 'all',
    };
  },
  computed: {
    ...mapGetters('authentication', ['workgroups']),
    ...mapGetters('metadata', ['userWorkgroups', 'getWorkgroupNameById']),
    ...mapGetters('cti', ['ActiveQueueNames']),

    workgroupsComparison() {
      if (!Array.isArray(this.userWorkgroups)) return [];

      const activeQueues = Array.isArray(this.ActiveQueueNames?.activeQueueNames)
        ? this.ActiveQueueNames.activeQueueNames
        : [];

      return this.userWorkgroups.map(wg => {
        const id = typeof wg === 'object' && wg.id ? wg.id : wg;
        const rawName = this.getWorkgroupNameById(id);
        const name = rawName?.trim() || 'Onbekend';

        // Check if the workgroup exists in CRM and CTI
        const inCRM = this.userWorkgroups.includes(id);
        const inCTI = rawName ? activeQueues.includes(rawName) : false;
        const isEnabled = inCRM && inCTI;

        // Where is it disabled?
        const disabledIn = [];
        if (!inCRM) disabledIn.push('CRM');
        if (!inCTI) disabledIn.push('CTI');

        return {
          id,
          name,
          isEnabled,
          disabledIn,
        };
      });
    },

    // Search/filter + sort
    sortedAndFilteredWorkgroups() {
      let filtered = [...this.workgroupsComparison];

      // Search filter
      if (this.search.length >= 4) {
        const searchLower = this.search.toLowerCase();
        filtered = filtered.filter(wg => wg.name.toLowerCase().includes(searchLower));
      }

      // Status filter
      if (this.statusFilter === 'enabled') {
        filtered = filtered.filter(wg => wg.isEnabled);
      } else if (this.statusFilter === 'disabled') {
        filtered = filtered.filter(wg => !wg.isEnabled);
      }

      // Sort
      return filtered.sort((a, b) =>
        this.sortAsc
          ? (a.name || '').localeCompare(b.name || '')
          : (b.name || '').localeCompare(a.name || '')
      );
    },
  },
  methods: {
    toggleSort() {
      this.sortAsc = !this.sortAsc;
    },
  },
  created() {
    console.log('CRM workgroups:', this.userWorkgroups);
    console.log('CRM workgroups with names:', this.userWorkgroups.map(id => this.getWorkgroupNameById(id)));
    console.log('CTI ActiveQueueNames:', this.ActiveQueueNames);
    console.log('Workgroups comparison:', this.workgroupsComparison);
  },
};
</script>

<style scoped>
.workgroup-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1rem;
}

.search-bar {
  display: flex;
  align-items: center;
}

.search-wrapper {
  position: relative;
  width: 100%;
}

.search-icon {
  position: absolute;
  top: 53%;
  left: 1rem;
  transform: translateY(-50%);
}

.search-input {
  width: 100%;
  padding-left: 3rem;
}

.sort-icon {
  font-size: 1.4rem;
  color: #555;
  cursor: pointer;
}

.sort-icon:hover {
  color: #000;
}

.workgroup-list {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid #e0e6ed;
  border-radius: 6px;
  max-height: 300px;
  overflow-y: auto;
}

.workgroup-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #f0f3f8;
  padding-right: 1rem;
}

.workgroup-info {
  display: flex;
  flex-direction: column;
  padding: 0.55rem 1rem;
}

.workgroup-info small {
  font-size: 1.3rem;
}

.no-workgroup {
  padding: 10rem;
  text-align: center;
  color: #888;
}

.text-red-600 {
  color: #dc2626;
}
</style>
